import api from './api'

export interface College {
  college_id: number
  college_name: string
  college_type: 'management' | 'engineering' | 'both'
  tier: 'tier1' | 'tier2'
  tpo_email_id?: string | null
  tpo_phone_number?: string | null
  created_by_email?: string
  created_at?: string
  updated_by_email?: string
  updated_at?: string
}
export type CollegeInput = Pick<College, 'college_name' | 'college_type' | 'tier' | 'tpo_email_id' | 'tpo_phone_number'>
export const collegeAPI = {
  options: (params: { q?: string; college_type?: string; tier?: string }) => api.get<College[]>('/colleges/options', { params }),
  list: () => api.get<College[]>('/colleges'),
  create: (data: CollegeInput) => api.post('/colleges', data),
  update: (id: number, data: CollegeInput) => api.put(`/colleges/${id}`, data),
}
